import { useEffect, useState } from "react";
import * as projectsService from "../service/projects";
import useProjectStore from "../store/projects";

export const useGetProjects = () => {
  const [refresh, setRefresh] = useState(false);
  const {
    projects,
    setProjects,
    loading,
    setLoading,
    pagination,
    setPagination,
    filters,
    setFilters,
  } = useProjectStore();

  useEffect(() => {
    setLoading(true);
    projectsService.get(filters, pagination).then((response) => {
      setProjects(response.content);
      setPagination({
        page: response.pageable.pageNumber,
        size: response.pageable.pageSize,
        totalElements: response.totalElements,
      });
      setLoading(false);
    });
  }, [refresh, setLoading, setProjects, setPagination]);

  const refreshProjects = (page) => {
    if (page !== undefined && page !== null) {
      setPagination({ ...pagination, page });
    }
    setRefresh(!refresh);
  };

  const filterProjects = (newFilters) => {
    setFilters(newFilters);
    setPagination({ ...pagination, page: 0 });
    setRefresh(!refresh);
  };

  return {
    projects,
    refreshProjects,
    loading,
    filterProjects,
    filters,
    pagination,
  };
};
export const useGetAllProjects = () => {
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const getAllProjects = async () => {
    setLoading(true);
    try {
      const response = await projectsService.get();
      setProjects(response.content);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      throw error;
    }
  };

  useEffect(() => {
    getAllProjects();
  }, []);
  return { projects, loading };
};
export const useCreateProject = () => {
  const createProject = async (project) => {
    return projectsService.create(project);
  };

  return { createProject };
};

export const useUpdateProject = () => {
  const updateProject = async (project) => {
    return projectsService.update(project.id, project);
  };
  return { updateProject };
};

export const useDeleteProject = () => {
  const { setLoading } = useProjectStore();

  const deleteProject = async (project) => {
    setLoading(true);
    try {
      const result = await projectsService.remove(project.id);
      setLoading(false);
      return result;
    } catch (error) {
      setLoading(false);
      throw error;
    }
  };

  return { deleteProject };
};

export const useCreateCollaborators = () => {
  const createCollaborators = async (id, collaborators) => {
    return projectsService.updateProjectCollaborators(id, collaborators);
  };

  return { createCollaborators };
};
